import React from 'react';
import ListItem from '@mui/material/ListItem';
import Menu from '@mui/material/Menu';
import ListItemText from '@mui/material/ListItemText';
import EditAttributesIcon from '@mui/icons-material/EditAttributes';

import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';

import CloseIcon from '@mui/icons-material/Close';

import {
  Standard as StandardDataField,
  Ringtyp as RingtypDataField,
} from "../Entity/Kennzeichnung/StandardDataFields";

const CreatureConfigDialog = (props) => {

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpenKennzeichnung = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseKennzeichnung = () => {
    setAnchorEl(null);
  };

  return(
      <div>
      <Button
        color="primary"
        aria-haspopup="true"
        aria-controls="lock-menu"
        aria-label="Kennzeichnungen und Beschreibungen anpassen"
        onClick={handleOpenKennzeichnung}
      >
        <EditAttributesIcon />&nbsp;Kennzeichnungen und Beschreibung anpassen
      </Button>
      
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseKennzeichnung}
      >

      <ListItem 
        button
        onClick={
          ()=>handleCloseKennzeichnung()
        }
        secondaryAction={
          <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}} 
            edge="end" 
            aria-label="Kennzeichnungsdialog Schließen"
          >
            <CloseIcon />
          </IconButton>
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-exit"} 
          primary={<h3 style={{margin:"0 0 5px"}}>Angaben zum Exemplar</h3>}
        />

      </ListItem>

      <Divider/>

      {props.creature.kennzeichnungAnpassen.spezies &&
      <ListItem
        button
        onClick={
          ()=>props.creature.hasOwnProperty("spezies") 
          ?(()=>{
            props.removeEntity("spezies")
            props.updaterValueAnzahl(1)
          })()
          :props.addEntity("spezies", {}) 

        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("spezies")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-spezies" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-spezies"} 
          primary="Spezies" 
        />

      </ListItem>
      }

      <ListItem
        button
        onClick={
          ()=>{
            if (props.creature.hasOwnProperty("ringtyp")) {
              props.removeEntity("ringtyp")
              props.removeEntity("ringnummer")
              props.removeEntity("ringkommentar")
            } else {
              props.addEntity("ringtyp", RingtypDataField())
              props.addEntity("ringnummer", StandardDataField())
            }
          } 
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("ringtyp")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-ring" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-ring"} 
          primary="Ring" 
        />
      </ListItem>

      <ListItem
        button
        onClick={
          ()=>props.creature.hasOwnProperty("microchip") 
          ?props.removeEntity("microchip") 
          :props.addEntity("microchip", StandardDataField())           
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("microchip")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-microchip" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-microchip"} 
          primary="Microchip/Transponder" 
        />
      </ListItem>

      <ListItem
        button
        onClick={
          ()=>props.creature.hasOwnProperty("meldeid") 
          ?props.removeEntity("meldeid") 
          :props.addEntity("meldeid",StandardDataField())           
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("meldeid")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-meldeid" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-meldeid"} 
          primary={props.meldenummerAnzeigename} 
        />
      </ListItem>

      <ListItem
        button
        onClick={
          ()=>{
            if (props.creature.hasOwnProperty("andereKennzeichnungArt")) {
              props.removeEntity("andereKennzeichnungArt")
              props.removeEntity("andereKennzeichnungBeschreibung")
            } else {
              props.addEntity("andereKennzeichnungArt", StandardDataField())
              props.addEntity("andereKennzeichnungBeschreibung", StandardDataField())
            }
          }  
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("andereKennzeichnungArt")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-andereKennzeichnungArt" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-andereKennzeichnungArt"} 
          primary="Andere Art der Kennzeichnung" 
        />
      </ListItem>

      <ListItem
        button
        onClick={
          ()=>{
            if (props.creature.hasOwnProperty("zuchtbuchNummerDesBuches")) {
              props.removeEntity("zuchtbuchNummerDesBuches")
              props.removeEntity("zuchtbuchNummerDesTieres")
            } else {
              props.addEntity("zuchtbuchNummerDesBuches", StandardDataField())
              props.addEntity("zuchtbuchNummerDesTieres", StandardDataField())
            }
          }
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("zuchtbuchNummerDesBuches")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-zuchtbuch" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-zuchtbuch"} 
          primary="Zuchtbuch" 
        />
      </ListItem>

      <ListItem
        button
        onClick={ 
          ()=>props.creature.hasOwnProperty("fotodokumentation") 
              ?props.removeEntity("fotodokumentation") 
              :props.addEntity("fotodokumentation", {}) 
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("fotodokumentation")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-fotodokumentation" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-fotodokumentation"} 
          primary="Fotodokumentation" 
        />
      </ListItem>

      <ListItem
        button
        onClick={
          ()=>props.creature.hasOwnProperty("dokumente") 
          ?props.removeEntity("dokumente") 
          :props.addEntity("dokumente", {}) 
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("dokumente")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-dokumente" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-dokumente"} 
          primary="Dokumente" 
        />
      </ListItem>

      <ListItem
        button
        onClick={
          ()=>props.creature.hasOwnProperty("groesse") 
          ? props.removeEntity("groesse") 
          : props.addEntity("groesse", StandardDataField())
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("groesse")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-groesse" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-groesse"} 
          primary="Größe" 
        />
      </ListItem>

      <ListItem
        button
        onClick={
          ()=>props.creature.hasOwnProperty("gewicht") 
          ? props.removeEntity("gewicht") 
          : props.addEntity("gewicht", StandardDataField())
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("gewicht")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-gewicht" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-gewicht"} 
          primary="Gewicht" 
        />
      </ListItem>

      {props.creature.kennzeichnungAnpassen.geschlechtsverhaeltnis &&
      <ListItem
        button
        onClick={
          ()=>props.creature.hasOwnProperty("anzahlMale") 
          ? (()=>{
            props.removeEntity("anzahlMale")
            props.removeEntity("anzahlFemale")
            props.removeEntity("anzahlGenderUnknown")
            props.addEntity("geschlecht", StandardDataField())
            if (props.rufnamenZeigen) {
              props.addEntity("rufname", StandardDataField())
            }
          })()
          : (()=>{
            props.removeEntity("geschlecht")
            props.removeEntity("rufname")
            props.addEntity("anzahlMale", StandardDataField())
            props.addEntity("anzahlFemale", StandardDataField())
            props.addEntity("anzahlGenderUnknown", StandardDataField())
          })()
        }
        secondaryAction={
          <Checkbox
            edge="end"
            checked={props.creature.hasOwnProperty("anzahlMale")}
            inputProps={{ 'aria-labelledby': props.uid+"-switch-list-label-anzahlGender" }}
          />
        }
      >
        <ListItemText 
          id={props.uid+"-switch-list-label-anzahlGender"} 
          primary="Geschlechtsverhältnis angeben" 
        />
      </ListItem>
      }

    </Menu>
    </div>
  )
}

export default CreatureConfigDialog;
